import React, { memo } from "react";
import Form from "react-bootstrap/Form";

interface InputRadioProps {
  id: string;
  name: string;
  value: string;
  isChecked: boolean;
  placeholder: string;
  onChange: (e:any) => void;
}

const InputRadio = memo(({ id, name, placeholder, value, onChange, isChecked }: InputRadioProps) => {
  return (
    <Form.Check
      type="radio"
      id={id}
      name={name}
      value={value}
      checked={isChecked}
      onChange={onChange}
      label={placeholder}
    />
  );
});

InputRadio.displayName = 'InputRadio';

export default InputRadio;
